import { useEffect } from 'react';
import { Button } from 'react-aria-components';
import { ErrorLevel, logErrorToSentry } from '~/utilities';
import { Alert } from '@janeapp/burrito-design-system';

interface ErrorViewProps {
  message: string;
  userMessage?: string;
  type?: ErrorLevel;
  onRetry?: () => void;
}

export const ErrorView = ({
  userMessage,
  message,
  type = ErrorLevel.Error,
  onRetry,
}: ErrorViewProps) => {
  useEffect(() => logErrorToSentry({ type, message }), [type, message]);

  return (
    <div className="mt-1 flex px-4 py-3" data-testid="error-view">
      <Alert tone="warning">
        <Alert.Content>
          {userMessage ?? 'Something went wrong.'}
          {!!onRetry && (
            <Button
              className="block font-semibold text-warning-70 underline"
              onPress={onRetry}
              data-testid="error-view-retry-button"
            >
              Retry now
            </Button>
          )}
        </Alert.Content>
      </Alert>
    </div>
  );
};
